import {ReachSegment} from "../../apis/requests/segments/types";
import {FilterOption, uniqueSorted} from "../../ui/components";
import {SEGMENT_CATEGORIES, SEGMENT_CATEGORY_INFO} from "./segment-form/constants";
import {categoryBucketLabel} from "./segment-form/helpers";
import {compareFallbackLast} from "./segmentCategoryBlocks";

export const UNCATEGORIZED_SEGMENTS_SECTION = "Uncategorized segments";

export const segmentFilterOptions = (
  segmentNames: string[],
  segments: Pick<ReachSegment, "name" | "segment_category" | "is_category_fallback">[]
): FilterOption[] => {
  const segmentByName = new Map(segments.map((segment) => [segment.name, segment]));
  const names = uniqueSorted(segmentNames);
  const categorized = SEGMENT_CATEGORIES.flatMap((segmentCategory) =>
    names
      .flatMap((name) => {
        const segment = segmentByName.get(name);
        return segment?.segment_category === segmentCategory ? [segment] : [];
      })
      .sort(compareFallbackLast)
      .map((segment) => ({
        value: segment.name,
        label: categoryBucketLabel(segment),
        section: SEGMENT_CATEGORY_INFO[segmentCategory].label,
        sectionColor: SEGMENT_CATEGORY_INFO[segmentCategory].color,
        exclusiveGroup: segmentCategory,
      }))
  );
  const uncategorized = names
    .filter((name) => !segmentByName.get(name)?.segment_category)
    .map((name) => ({
      value: name,
      label: name,
      section: categorized.length > 0 ? UNCATEGORIZED_SEGMENTS_SECTION : undefined,
    }));
  return [...categorized, ...uncategorized];
};
